/* TwoClickAppInstallError.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { Stack } from '@atlaskit/primitives';
import { H4 } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _2 = "._4cvr1h6o{align-items:center}";
const _ = "._1e0c1txw{display:flex}";
const contentStyles = null;
export const TwoClickAppInstallError = () => {
  return /*#__PURE__*/_jsxs(Stack, {
    space: "space.800",
    children: [/*#__PURE__*/_jsx(H4, {
      children: "Error"
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1e0c1txw _4cvr1h6o _syaz131l"]),
        children: [/*#__PURE__*/_jsx(WarningIcon, {
          primaryColor: "var(--ds-icon-danger, #C9372C)",
          label: ""
        }), /*#__PURE__*/_jsx("span", {
          children: "We ran into a little trouble."
        })]
      })]
    })]
  });
};